import React from "react";
import nursingHomeStore from "@source/store/nursingHomeStore";
import {hasConsentPermission} from "@source/utils/consentAccess";
import {OrganizationPermissionsEnum} from "@source/api/models/permissionsModels";
import {CategoryLibrary} from "./categoryLibrary";
import {ConsentRequestState} from "@source/components/consentDocuments";
import ConsentDocumentsLayout from "../consentDocumentsLayout";

export const CategoriesPage = () => {
  const organizationId = nursingHomeStore.activeNursingHome?.organization?._id || "";
  const canManage = hasConsentPermission(OrganizationPermissionsEnum.MANAGE_CONSENT_CATEGORIES);
  return <ConsentDocumentsLayout>{organizationId ? <CategoryLibrary organizationId={organizationId} canManage={canManage}/> : <ConsentRequestState variant="empty" title="Select a nursing home" description="Choose a nursing home with an organization to view Consent Categories."/ >}</ConsentDocumentsLayout>;
};
